/**
 * Created by Florin David on 30/06/2020.
 */

import Action, { ADD_CHAT_ENTRY, SET_SESSION_ID } from 'constants/action-types'

/**
 * Session ID
 */
export default (state = null, action: Action): string | null => {
  switch (action.type) {
    case SET_SESSION_ID:
      return action.payload
    case ADD_CHAT_ENTRY:
      return action.payload.response.sessionId || null
    default:
      return state
  }
}
